import { gql } from '@apollo/client';

export const GET_CART = gql`
  query GetCart {
    cart {
      id
      courseId
      programId
      status
      mode
      userId
      organisationId
      createdAt
      course {
        id
        openedxCourseId
        details: _CourseOverviewsCourseoverview {
          displayName
          courseImageUrl
          shortDescription
        }
        modes: _CourseModesCoursemode {
          modeSlug
          minPrice
          modeDisplayName
          currency
        }
      }
      program {
        id
        name
        image
        price
        description
      }
    }
  }
`;

export const GET_ORG_ID_BY_NAME = gql`
  query GetOrgIdByName($orgName: Text) {
    organisations(where: { name: { _eq: $orgName } }) {
      id
      name
    }
  }
`;

export const INSERT_COURSE_TO_CART = gql`
  mutation InsertCourseToCart(
    $courseId: Uuid!
    $userId: Int4!
    $organisationId: Uuid!
    $status: Text!
    $mode: Text!
  ) {
    v2InsertCart(
      objects: {
        courseId: $courseId
        userId: $userId
        organisationId: $organisationId
        status: $status
        mode: $mode
      }
    ) {
      affectedRows
    }
  }
`;

export const INSERT_PROGRAM_TO_CART = gql`
  mutation InsertProgramToCart(
    $programId: Uuid!
    $userId: Int4!
    $organisationId: Uuid!
    $status: Text!
  ) {
    v2InsertCart(
      objects: {
        programId: $programId
        userId: $userId
        organisationId: $organisationId
        status: $status
      }
    ) {
      affectedRows
    }
  }
`;

export const UPDATE_CART_ITEM = gql`
  mutation UpdateCartItem($keyId: Uuid!, $status: Text!, $mode: Text!) {
    v2UpdateCartById(
      keyId: $keyId
      updateColumns: { status: { set: $status }, mode: { set: $mode } }
    ) {
      affectedRows
    }
  }
`;

export const DELETE_CART_ITEM = gql`
  mutation DeleteCartItem($keyId: Uuid!) {
    v2DeleteCartById(keyId: $keyId) {
      affectedRows
    }
  }
`;
